<script>
  import { Link, page, router } from '@inertiajs/svelte';
  import GlassBackground from '@/components/GlassBackground/index.svelte';
  import Button from '@/components/Button.svelte';

  const currentUser = $derived($page?.props?.current_user || null);

  function logOut() {
    if (currentUser?.current_session_id) {
      router.delete(`/sessions/${currentUser.current_session_id}`);
    }
  }
</script>

<div class="sticky top-0 z-50">
  <GlassBackground>
    <nav class="flex items-center justify-between p-4">
      <div class="text-xl font-bold">
        <Link href="/">MASET</Link>
      </div>

      <div class="flex gap-4">
        {#if currentUser}
          <Button variant="outline" onclick={logOut}>Log out</Button>
          <Link href="/dashboard">
            <Button variant="black">Dashboard</Button>
          </Link>
        {:else}
          <Link href="/sign_up">
            <Button variant="outline">Sign up</Button>
          </Link>
          <Link href="/sign_in">
            <Button variant="black">Log in</Button>
          </Link>
        {/if}
      </div>
    </nav>
  </GlassBackground>
</div>
